import React, { useState } from 'react';
import { Box, Typography, Paper, Container } from '@mui/material';
import ScaleIcon from '@mui/icons-material/Scale';
import Dialog from '@mui/material/Dialog';
import UnitList from './UnitList';
import UnitForm from './UnitForm';

const UnitSettings = () => {
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [unitDialogOpen, setUnitDialogOpen] = useState(false);

  const handleUnitEdit = (unit) => {
    setSelectedUnit(unit);
    setUnitDialogOpen(true);
  };

  const handleUnitSuccess = () => {
    setSelectedUnit(null);
    setUnitDialogOpen(false);
    setRefresh(!refresh);
  };

  const handleAddUnit = () => {
    setSelectedUnit(null);
    setUnitDialogOpen(true);
  };

  return (
    <Container className="settings-page" maxWidth="xl" sx={{ mt: 2, mb: 2, px: 2 }}>
      <Box className="settings-heading" sx={{ mb: 2 }}>
        <Typography 
          variant="h6" 
          sx={{ 
            fontWeight: 600,
            color: 'text.primary',
            mb: 0.5,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            fontSize: '1rem'
          }}
        >
          <ScaleIcon sx={{ fontSize: 24, color: '#00acc1' }} />
          Unit Management
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
          Manage your measurement units
        </Typography>
      </Box>

      <Paper className="settings-shell" sx={{ 
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: 1
      }}>
        <Box className="settings-content" sx={{ p: 2 }}>
          <UnitList 
            onEdit={handleUnitEdit} 
            onAdd={handleAddUnit}
            key={refresh} 
          />
        </Box>
      </Paper>

      {/* Unit Dialog */}
      <Dialog 
        open={unitDialogOpen} 
        onClose={() => {
          setUnitDialogOpen(false);
          setSelectedUnit(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <UnitForm 
          selected={selectedUnit} 
          onSuccess={handleUnitSuccess} 
          onCancel={() => {
            setUnitDialogOpen(false);
            setSelectedUnit(null);
          }} 
        />
      </Dialog>
    </Container>
  );
};

export default UnitSettings;
